import './ScheduleCard.css'

import React from 'react'
import { Card, CardMedia, CardTitle } from 'material-ui/Card'

import { truncate } from '../app/utils'

const styles = {
  cardHeadTitle: {
    fontSize: 11,
    color: 'white',
    marginLeft: 3,
    marginRight: 3,
  },
}

const ScheduleCard = ({
  id,
  headerTitle,
  title,
  subtitle,
  image,
  imageWidth,
  imageAlt,
  color,
  backgroundColor,
  width,
  height,
  headerHeight,
  rightHeaderTitle,
  onClick,
  margin,
}) => {
  // resonsive fonts, ...
  const isSmallMode = height < 180
  const cardStyle = {
    width,
    margin,
    cursor: onClick ? 'pointer' : 'default',
    backgroundColor: 'transparent',
  }
  const titleStyle = {
    fontSize: isSmallMode ? 16 : 20,
    lineHeight: isSmallMode ? '18px' : '24px',
  }
  const subtitleStyle = {
    fontSize: isSmallMode ? 13 : 15,
    lineHeight: isSmallMode ? '14px' : '18px',
  }
  const overlayTitleStyle = {
    padding: isSmallMode ? 6 : 12,
  }
  const subtitleMaxWords = isSmallMode ? 7 : 20
  return (
    <Card key={id} style={cardStyle} onClick={onClick}>
      <CardMedia
        overlay={
          <CardTitle
            style={overlayTitleStyle}
            title={title}
            subtitle={truncate(subtitle, subtitleMaxWords)}
            titleStyle={titleStyle}
            subtitleStyle={subtitleStyle}
          />
        }
        style={{ width }}
      >
        <div
          style={{
            width,
            height: headerHeight,
            backgroundColor: color,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
          }}
          className="ScheduleCard-headerContainer"
        >
          <span style={styles.cardHeadTitle}>{headerTitle}</span>
          <span
            className="App-uppercaseFirstLetter"
            style={{
              ...styles.cardHeadTitle,
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {rightHeaderTitle}
          </span>
        </div>
        <div
          style={{ width, height, backgroundColor }}
          className="ScheduleCard-imageContainer"
        >
          <img
            alt={imageAlt}
            style={{
              width: typeof imageWidth === 'number' ? imageWidth : height,
            }}
            src={image}
          />
        </div>
      </CardMedia>
    </Card>
  )
}

export default ScheduleCard



// WEBPACK FOOTER //
// ./src/components/ScheduleCard.js